import * as React from 'react';
import { Link } from 'react-router-dom';
import './user-link.scss';

interface Props {
    userId?: string | null;
    className?: string;
    children: React.ReactNode;
}

export const userEditPath = (userId: string) => `/dashboard/users/edit/${userId}`;

// لینک به صفحه ویرایش کاربر؛ اگر شناسه کاربر موجود نباشد فقط محتوا نمایش داده می‌شود
export const UserLink: React.FC<Props> = ({ userId, className, children }) => {
    if (!userId) return <>{children}</>;

    return (
        <Link
            to={userEditPath(userId)}
            target="_blank"
            className={`pmx-user-link${className ? ` ${className}` : ''}`}
            onClick={(e) => e.stopPropagation()}
        >
            {children}
        </Link>
    );
};
